import { useContext } from 'react'
import { AppContext, AppContextType } from './AppContext'


export const useApp = ():AppContextType => useContext(AppContext)